import React from 'react';
import isEqual from 'lodash/isEqual';
import uniqueId from 'lodash/uniqueId';
import { Box } from '@material-ui/core';

import FlashMessage, { FlashMessageProps } from '#web-components/components/FlashMessage';

export interface ValidationMessagesProps {
  messages?: Array<string>;
  flashMessagesProps?: Partial<FlashMessageProps>;
}

export function propsComparator(
  { messages: prevMessages }: ValidationMessagesProps,
  { messages: nextMessages }: ValidationMessagesProps,
) {
  return isEqual(prevMessages, nextMessages);
}

export default function ValidationMessages({ messages, flashMessagesProps } : ValidationMessagesProps) {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      { messages && messages.map((message) => (
        <Box mb={4} key={uniqueId()}>
          <FlashMessage
            status="error"
            message={message}
            {...flashMessagesProps}
          />
        </Box>
      )) }
    </>
  );
}
